import { render, staticRenderFns } from "./loufengBigPicture.vue?vue&type=template&id=07f31d64&scoped=true&"
import script from "./loufengBigPicture.vue?vue&type=script&lang=js&"
export * from "./loufengBigPicture.vue?vue&type=script&lang=js&"
import style0 from "./loufengBigPicture.vue?vue&type=style&index=0&id=07f31d64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f31d64",
  null
  
)

export default component.exports